import { createApi, createBaseQuery } from '@adv-frontend/modules-query';
import { apiV1Request } from '#shared/api/requests';
import {
    getOpenApiGetAddonsByVariantIDUrl,
    OpenApiGetAddonsByVariantIDMethod,
    type OpenApiGetAddonsByVariantIDPathParameters,
    type OpenApiGetAddonsByVariantIDResponseSuccess,
} from '#shared/api/schema';

const PRODUCT_ADDONS_TAG = 'productAddons' as const;

const addonApi = createApi({
    name: 'entities/product/api/addon',
    tagTypes: [PRODUCT_ADDONS_TAG],
    baseQuery: createBaseQuery(apiV1Request),
    endpoints: (builder) => {
        return {
            getAddons: builder.query<
                OpenApiGetAddonsByVariantIDResponseSuccess,
                { params: OpenApiGetAddonsByVariantIDPathParameters }
            >({
                query: ({ params }) => {
                    return {
                        url: getOpenApiGetAddonsByVariantIDUrl(params),
                        method: OpenApiGetAddonsByVariantIDMethod,
                    };
                },
                providesTags: (result, error) => {
                    if (error || !result) {
                        return [];
                    }

                    return [PRODUCT_ADDONS_TAG];
                },
            }),
        };
    },
});

export const useGetProductAddons = addonApi.useGetAddonsQuery;

export const invalidateProductAddons = () => {
    addonApi.util.invalidateTags([PRODUCT_ADDONS_TAG]);
};
